import { render, staticRenderFns } from "./reset-username.vue?vue&type=template&id=be0bec90&scoped=true&"
import script from "./reset-username.vue?vue&type=script&lang=js&"
export * from "./reset-username.vue?vue&type=script&lang=js&"
import style0 from "./reset-username.vue?vue&type=style&index=0&id=be0bec90&prod&lang=css&"
import style1 from "./reset-username.vue?vue&type=style&index=1&id=be0bec90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0bec90",
  null
  
)

export default component.exports